import React from 'react';
import Marketing from '../images/marketing.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Event Planning & Management',
    description: 'Organize successful events with expert planning and management. We handle logistics, promotion, and execution to ensure a smooth and impactful event.',
  },
  {
    icon: <FaLock />,
    title: 'Crisis Management',
    description: 'Protect your brand with effective crisis management. We develop strategies to address and resolve issues, minimizing damage to your reputation.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Influencer Partnerships',
    description: 'Enhance your brand’s reach with influencer partnerships. We connect you with influencers who align with your brand values and target audience.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Product Launches',
    description: 'Create buzz with successful product launches. Our services include planning, promotion, and execution to ensure a strong market entry.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Media Engagement',
    description: 'Build positive media relationships with strategic engagement. We craft press releases, media kits, and pitches to gain favorable coverage and exposure.',
  },

];

const PublicRelation = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={Marketing}
        alt="Marketing Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Public Relations</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
        <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Marketing Services</h2>
        <p className="text-md text-black mb-6 px-12 text-left">
        Maximize efficiency, enhance security, and drive growth with our tailored Marketing Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Marketing planning to meet your business needs.
        </p>
        
        <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
        </div>
      </section>

    </div>

    </div>
  )
}

export default PublicRelation
